import { Component, OnInit, Input } from '@angular/core';
import { Contact } from '../../shared/models/contact';
@Component({
  selector: 'app-contact-view',
  templateUrl: './contact-view.component.html',
  styleUrls: ['./contact-view.component.scss']
})
export class ContactViewComponent implements OnInit {

  @Input() contact: Contact;
  
  constructor() { }

  ngOnInit() {
  }

}
